// Module
var code = "<div v-if=\"show\" ref=\"tooltipContent\" v-click-away=\"clickedAway\" :class=\"['tooltip_content', `-${direction}`]\"> <div ref=\"tooltipPointer\" class=\"arrow\"> <cSvg height=\"7\" href=\"#tooltip-arrow\" width=\"28\"/> </div> <slot></slot> </div> ";
// Exports
export default code;